import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom'
import { IoMdReturnLeft } from 'react-icons/io';
import { useQuery, useMutation, useLazyQuery } from '@apollo/client';
import Swal from 'sweetalert2';
import * as queries from '../../queries';
import Pagination from '../../utils/Pagination'
import DataTable from '../../utils/DataTable';
import SearchBarGraph from '../../utils/SearchBarGraph';
import { formatLocalTime } from '../../utils/TimeUtils';
import { axiosInstance } from '../../utils/axiosInterceptor.js';
import { useGeneralInfo } from '../../utils/GeneralnfoContext.js';
import CustomerCreditLog from '../CustomerAdmin/CustomerCreditLog.jsx';
import CryptoJS from 'crypto-js';

function CustomerDetail() {
    const user = JSON.parse(localStorage.getItem('user'));

    const { t } = useTranslation();
    const { targetReturn, setReturnFunction, setTargetReturn } = useGeneralInfo();
    const { id } = useParams();
    const navigate = useNavigate();
    const [newCredit, setNewCredit] = useState(0);
    const [upsertEditCredit] = useMutation(queries.EDITCREDIT);
    const [createCreditLog] = useMutation(queries.CREATE_CREDIT_LOG);
    const [upsertEditNote] = useMutation(queries.EDITNOTICE);
    const [setIsCashPayer] = useMutation(queries.EDITCASHPAYER);
    const [upsertAccountLevel] = useMutation(queries.EDITACCOUNTLEVEL);
    const apiUrl = process.env.REACT_APP_API_URL;
    const emailPass = process.env.REACT_APP_EMAILPASS;

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState({});
    const [selectedOptions, setSelectedOptions] = useState('');
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const origin = searchParams.get('origin');
    const [orderBy, setOrderBy] = useState(['-AppointmentTime', 'AuctionID']);

    const [swalShown, setSwalShown] = useState(false)
    const [genRandPass, setGenRandPass] = useState(null)

    const { error, data, refetch } = useQuery(queries.GET_CUSTOMERINFO, {
        variables: {
            CustomerID: parseInt(id),
            orderBy,
            page,
            pageSize,
            search,
            filters: {
                ...filters, // Spread the original filters object
                CustomerID: parseInt(id), // Add the CustomerID field
            },
        },
    });

    const [searchCusHibidInfoByEmail] = useLazyQuery(queries.VERIFY_HIBID_EMAIL);
    const [sendConfirmEmail] = useMutation(queries.CUSTOMER_REGISTER_CONFIRM_EMAIL);
    const [regWithPassNoValid] = useMutation(queries.CUSTOMER_REGISTER_CONFIRM_EMAIL_F_VAL);

    useEffect(() => {
        setReturnFunction(true);
    }, []);
    useEffect(() => {
        if (targetReturn) {
            setTargetReturn(false);
            setReturnFunction(false);
            window.location.replace(`${origin}`);
        }
    }, [targetReturn]);

    useEffect(() => {
        if (data) {
            const customerData = data?.allCustomer?.data || [];
            const customer = customerData[0] || {};
            setNewCredit(customer.Credit || 0); // Set initial credit value
        }
    }, [data]);

    // if (loading) return <p>Loading...</p>;
    if (error) return <p>{t('Error:')}{error.message}</p>;

    const customerData = data?.allCustomer?.data || [];
    const auctionData = data?.allOrderView?.data || [];
    const totalPageNum = data?.allOrderView?.totalPageNum || 1;
    const totalCount = data?.allOrderView?.totalCount || 0;

    const customer = customerData[0] || {};


    const handleEditCredit = () => {
        Swal.fire({
            title: 'Enter new credit and password',
            html: `
            <div class="confirm-pay-batch-detail-popup">
                <div>
                    <span> <b>Current Customer Credit:</b> <span id="currentCredit">${customer.Credit}</span></span>
                </div>
                <div>
                    <label for="changeCredit"><strong>Change:</strong></label>
                    <input type="number" id="changeCredit" class="swal2-input" placeholder="New Credit" value="0">
                </div>

                <div>
                    <span> <b>After Change:</b> <span id="afterCredit">${customer.Credit}</span></span>
                </div>
                <div>
                    <label for="reason"><strong>Reason: </strong></label>
                    <textarea id="reason" rows="7" class="swal2-textarea" placeholder="Reason for this change"></textarea>
                </div>
                <div>
                    <label for="invoiceID"><strong>Related invoice: </strong>(Optional) (Help you locate the invoice) </label>
                    <input type="text" id="invoiceID" class="swal2-input" placeholder="invoice ID related with this edit">
                </div>
                <div>
                    <label for="password"><strong>Password:</strong></label>
                    <input type="password" id="password" class="swal2-input" placeholder="Password">
                </div>
            </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Submit',
            didOpen: () => {
                const changeCredit = document.getElementById("changeCredit");
                const afterCredit = document.getElementById("afterCredit");

                changeCredit.addEventListener("change", (event) => {
                    try {
                        const value = parseFloat(event.target.value);
                        if (!isNaN(value)) {
                            afterCredit.textContent = parseFloat(parseFloat(customer.Credit) + parseFloat(value)).toFixed(2)
                        } else {
                            afterCredit.textContent = "Invalid Change Credit";
                        }
                    } catch (error) {
                        console.error(error)
                    }
                });
            },
            preConfirm: () => {
                const changeCreditValue = parseFloat(document.getElementById('changeCredit').value);
                const newCreditValue = parseFloat(document.getElementById('afterCredit').textContent);
                const reason = document.getElementById('reason').value;
                const invoiceID = document.getElementById('invoiceID').value;
                const password = document.getElementById('password').value;

                if (isNaN(newCreditValue)) {
                    Swal.showValidationMessage('Please enter a valid credit value');
                    return false;
                }

                if (changeCreditValue === 0) {
                    Swal.showValidationMessage('The change amount is 0, please hit Cancel button to exit if you want to cancel this action. ');
                    return false;
                }

                if (!reason) {
                    Swal.showValidationMessage('Reason is required');
                    return false;
                }

                if (password !== process.env.REACT_APP_CREDITPASS) {
                    Swal.showValidationMessage('Incorrect password');
                    return false;
                }

                return { newCreditValue: newCreditValue, changeCreditValue: changeCreditValue, reason: reason, invoiceID: invoiceID };
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                createCreditLog({
                    variables: {
                        CustomerID: id,
                        OriginAmount: customer.Credit,
                        ModifiedAmount: result.value.changeCreditValue,
                        FinalAmount: result.value.newCreditValue,
                        Operator: user.UserName,
                        Reason: result.value.reason,
                        InvoiceID: result.value.invoiceID,
                    }
                }).catch(() => {
                    Swal.fire('Error', 'Error insert credit log', 'error');
                    return
                });

                upsertEditCredit({ variables: { CustomerID: id, Credit: result.value.newCreditValue } })
                    .then(() => {
                        Swal.fire('Success', 'Credit updated successfully', 'success');
                        refetch();
                    })
                    .catch(() => {
                        Swal.fire('Error', 'Error updating credit', 'error');
                    });
            }
        });
    };

    const showCreditHistory = async () => {
        Swal.fire({
            title: 'Credit History',
            width: "90%",
            confirmButtonText: "Close",
            didOpen: () => setSwalShown(true),
            didClose: () => setSwalShown(false),
        })
    };

    const handleEditAccountLevel = () => {
        Swal.fire({
            title: 'Enter new Account Level and password',
            html: `
                <input type="number" id="newAccountLevel" class="swal2-input" placeholder="new Account Level" value="${customer.AccountLevel}">
                <input type="password" id="password" class="swal2-input" placeholder="Password">
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Submit',
            preConfirm: () => {
                const newAccountLevel = parseFloat(document.getElementById('newAccountLevel').value);
                const password = document.getElementById('password').value;

                if (isNaN(newAccountLevel)) {
                    Swal.showValidationMessage('Please enter a valid Account Level value');
                    return false;
                }

                if (password !== process.env.REACT_APP_CREDITPASS) {
                    Swal.showValidationMessage('Incorrect password');
                    return false;
                }

                return { newAccountLevel };
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                upsertAccountLevel({ variables: { CustomerID: id, AccountLevel: result.value.newAccountLevel } })
                    .then(() => {
                        Swal.fire('Success', 'Account Level updated successfully', 'success');
                        refetch();
                    })
                    .catch(() => {
                        Swal.fire('Error', 'Error updating Account Level', 'error');
                    });
            }
        });
    };

    const handleSetCashPayer = () => {
        Swal.fire({
            title: 'Enter password To Set CashPayer',
            html: `
                <input type="password" id="password" class="swal2-input" placeholder="Password">
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Submit',
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                const password = document.getElementById('password').value;
                if (password) {
                    setIsCashPayer({ variables: { CustomerID: id, IsCashPayer: !customer.IsCashPayer, Password: password } })
                        .then(() => {
                            Swal.fire('Success', 'IsCashPayer updated successfully', 'success');
                            refetch();
                        })
                        .catch(() => {
                            Swal.fire('Error', 'Error updating IsCashPayer', 'error');
                        });
                } else {
                    Swal.fire('Error', 'Password is required', 'error');
                }
            }
        });
    };

    const handleEditNotice = () => {
        Swal.fire({
            title: 'Enter new notice',
            html: `
                <textarea id="newNotice" class="swal2-textarea" placeholder="New Note">${customer.Note || ''}</textarea>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Submit',
            preConfirm: () => {
                const newNoticeValue = document.getElementById('newNotice').value;

                if (!newNoticeValue.trim()) {
                    Swal.showValidationMessage('Please enter a valid notice');
                    return false;
                }

                return { newNoticeValue };
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                upsertEditNote({ variables: { CustomerID: id, Note: result.value.newNoticeValue } })
                    .then(() => {
                        Swal.fire('Success', 'Note updated successfully', 'success');
                        refetch();
                    })
                    .catch(() => {
                        Swal.fire('Error', 'Error updating notice', 'error');
                    });
            }
        });
    };

    const handleDelete = async (invoice) => {
        const { isConfirmed: firstConfirm } = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to cancel this appointment?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, cancel it!',
            cancelButtonText: 'No!'
        });

        if (firstConfirm) {
            const { isConfirmed: secondConfirm } = await Swal.fire({
                title: 'Are you absolutely sure?',
                text: 'This action cannot be undone!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, cancel it!',
                cancelButtonText: 'No!'
            });

            if (secondConfirm) {
                try {
                    await axiosInstance.put(`${apiUrl}/api/invoices/${invoice.AuctionID}/${invoice.BidderID}/cancel`);
                    await refetch();
                } catch (error) {
                    console.error('Error deleting invoice:', error);
                }
            }
        }
    };

    const orderStatusMap = {
        0: 'Not Prepared',
        1: 'Prepared',
        2: 'Preparing',
        3: 'Holding',
        4: 'Picked',
        5: 'Abandoned',
    };

    // Define headers for DataTable
    const auctionHeaders = [
        { label: 'Appointment Time', field: 'AppointmentTime' },
        { label: 'Auction | BidCard', field: 'AuctionID' },
        // { label: '# of Lots', field: 'countLotID' },
        { label: 'Balance', field: 'Balance' },
        { label: 'TotalAmount', field: 'TotalAmount' },
        { label: 'Location', field: 'LocationCode' },
        { label: 'Status', field: 'OrderStatus' },
        { label: 'Pick Up Time', field: 'PickUpTime' },
    ];

    const customerInfoHeaders = [
        { label: 'Customer Code', field: 'AuctionFlexCode' },
        { label: 'Phone', field: 'Phone' },
        { label: 'Email', field: 'Email' },
    ];

    const addressHeaders = [
        { label: 'Address', field: 'Street' },
        { label: 'City', field: 'City' },
        { label: 'Province', field: 'Province' },
        { label: 'Postal Code', field: 'PostalCode' },
    ];

    // Define renderRow function for DataTable
    const renderAuctionRow = (item) => (
        <>
            <td>{item.AppointmentTime ? formatLocalTime(item.AppointmentTime) : 'No Appointment'}</td>
            <td>
                <a href={`/invoice-details-frontdesk/${item.AuctionID}/${item.BidderID}`} target="_blank" rel="noopener noreferrer">
                    {item.AuctionID} | {item.BidderID}
                </a>
            </td>
            {/* <td>{item.countLotID}</td> */}
            <td>{item.Balance} ({item.PaymentMethod})</td>
            <td>{item.TotalAmount}</td>
            <td>{item.LocationCode}</td>
            <td>{orderStatusMap[item.OrderStatus] || 'Unknown Status'}</td>
            <td>
                {!item.PickUpTime && item.AppointmentTime ? (
                    <button onClick={() => { handleDelete(item) }}>{t('Cancel Appointment')}</button>
                ) : (
                    formatLocalTime(item.PickUpTime)
                )}
            </td>
        </>
    );

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    const handleHeaderClick = (field) => {
        let sortField = field;
        if (typeof orderBy === 'string' && orderBy.includes(field)) {
            // If already sorted by this field, toggle between asc and desc
            sortField = orderBy.startsWith('-') ? field : '-' + field;
        }
        setOrderBy(sortField);
    };

    const handleSearch = (filter, searchTerm) => {
        if (filter) {
            setFilters(filter);
        }
        setSearch(searchTerm);
        setPage(1);

    };
    const handleReset = () => {
        setSearch('');
        setFilters({});
        setSelectedOptions('');
    };

    const handleSearchByChange = (newSearchBy, oldSearchBy) => {
        setSelectedOptions(newSearchBy);
        if (newSearchBy === '') {
            setFilters((prevFilters) => {
                const { [`${oldSearchBy}Ilike`]: _, ...rest } = prevFilters;
                return rest;
            });
            return;
        }
        const newFilters = { ...filters, [`${newSearchBy}Ilike`]: search };
        delete newFilters[`${oldSearchBy}Ilike`];
        setFilters(newFilters)
    };

    const searchOptions = [
        { value: '', label: 'All' },
        { value: 'AuctionID', label: 'AuctionID' },
        { value: 'BidderID', label: 'BidderID' },
        { value: 'LocationCode', label: 'LocationCode' }
    ];

    const verifyIdentity = async () => {
        const { value: password } = await Swal.fire({
            title: 'Enter the Operation password',
            input: 'password',
            inputPlaceholder: 'Enter the operation password',
            inputAttributes: {
                autocapitalize: 'off',
                autocorrect: 'off',
            },
            showCancelButton: true,
            confirmButtonText: 'Verify',
            preConfirm: (password) => {
                if (!password) {
                    Swal.showValidationMessage('Password is required');
                    return false;
                }
                if (password !== emailPass) {
                    Swal.showValidationMessage('Incorrect password');
                    return false;
                }
                return password;
            },
        });

        if (!password) {
            return false; // User cancelled the prompt
        }

        return true;
    }

    const sendRegistrationEmail = async () => {
        if (!await verifyIdentity()) {
            return;
        }
        if (!customer.Email) {
            Swal.fire('Email is missing');
            return false;
        }
        const emailRegex = /^[A-Za-z0-9._+\-\']+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;
        if (!customer.Email.match(emailRegex)) {
            Swal.fire('Customer has an invalid Email address');
            return false;
        }
        try {
            const customerInfoRes = await searchCusHibidInfoByEmail({ variables: { EmailIexact: customer.Email } });

            if (!customerInfoRes?.data?.allCustomer?.data[0]) {
                Swal.fire({
                    title: "Notice",
                    icon: "warning",
                    text: 'No customer found with the provided email. It could happen as the your data in the page is mismatching with the data base. Please try agin after refresh the page.'
                });
                return false;
            }

            if (customerInfoRes?.data?.allCustomer.length > 1) {
                Swal.fire({
                    title: "Notice",
                    icon: "warning",
                    text: 'More than one customer found with the provided email. It could happen as the customer may have two accounts. Please try search customers with the email.'
                });
                return false;
            }

            console.log(customerInfoRes.data.allCustomer.data[0])

            const customerHibidInfo = customerInfoRes.data.allCustomer.data[0];
            const encryptedPassword = CryptoJS.AES.encrypt("123456", process.env.REACT_APP_FRONT_END_ENCRY_KEY).toString();

            const response = await sendConfirmEmail({
                variables: {
                    email: customer.Email,
                    address: customerHibidInfo.CustomerHiBidInfoID.Street,
                    city: customerHibidInfo.CustomerHiBidInfoID.City,
                    country: customerHibidInfo.CustomerHiBidInfoID.Country,
                    fax: customerHibidInfo.CustomerHiBidInfoID.fax,
                    FirstName: customerHibidInfo.FirstName,
                    LastName: customerHibidInfo.LastName,
                    MiddleName: customerHibidInfo.MiddleName,
                    NickName: customerHibidInfo.FirstName.charAt(0).toUpperCase() + customerHibidInfo.LastName.charAt(0).toUpperCase() + Date.now(),
                    Phone: customerHibidInfo.CustomerHiBidInfoID.Phone,
                    province: customerHibidInfo.CustomerHiBidInfoID.Province,
                    registerPassword: encryptedPassword,
                    unit: customerHibidInfo.CustomerHiBidInfoID.UnitNum,
                    zip: customerHibidInfo.CustomerHiBidInfoID.PostalCode,
                    setPrimaryAddress: true
                }
            });

            console.log(customerHibidInfo.FirstName.charAt(0).toUpperCase() + customerHibidInfo.LastName.charAt(0).toUpperCase() + Date.now())

            if (response?.data.RegisterEmailConfirm.success) {
                Swal.fire({
                    icon: 'success',
                    title: t('Email Sent'),
                    html: `
                        <p class='swal-html-p-css success'>${t("Please ask customer to check their inbox (or sometimes junk mail) and confirm to finish registration.")}</p>
                    `,
                    showConfirmButton: true,
                    confirmButtonText: t('Close'),
                });

            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('Failed to Send Email'),
                    text: `${response.data.RegisterEmailConfirm.message || t("Failed to send email, please try again.")}`,
                    confirmButtonText: t('Close'),
                });
            }
        } catch (error) {
            Swal.fire('Lost connection with the server. Please try again after a few seconds and refresh the page.');
            return false;
        }
    };

    const registerRandomTempPassword = async () => {
        if (!await verifyIdentity()) {
            return;
        }
        if (!customer.Email) {
            Swal.fire('Email is missing');
            return false;
        }
        const emailRegex = /^[A-Za-z0-9._+\-\']+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;
        if (!customer.Email.match(emailRegex)) {
            Swal.fire('Customer has an invalid Email address');
            return false;
        }

        try {
            const customerInfoRes = await searchCusHibidInfoByEmail({ variables: { EmailIexact: customer.Email } });

            if (!customerInfoRes?.data?.allCustomer?.data[0]) {
                Swal.fire({
                    title: "Notice",
                    icon: "warning",
                    text: 'No customer found with the provided email. It could happen as the your data in the page is mismatching with the data base. Please try agin after refresh the page.'
                });
                return false;
            }

            if (customerInfoRes?.data?.allCustomer.length > 1) {
                Swal.fire({
                    title: "Notice",
                    icon: "warning",
                    text: 'More than one customer found with the provided email. It could happen as the customer may have two accounts. Please try search customers with the email.'
                });
                return false;
            }

            var generatePassword = (
                length = 10,
                numbers = '0123456789',
                uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                lowercase = 'abcdefghijklmnopqrstuvwxyz',
                special = '~!@-#$*'
            ) => {
                const allCharacters = numbers + uppercase + lowercase + special;

                const getRandomChar = (set) =>
                    set[crypto.getRandomValues(new Uint32Array(1))[0] % set.length];

                const mandatoryChars = [
                    getRandomChar(numbers),
                    getRandomChar(uppercase),
                    getRandomChar(lowercase),
                    getRandomChar(special)
                ];

                const remainingLength = length - mandatoryChars.length;

                const remainingChars = Array.from(crypto.getRandomValues(new Uint32Array(remainingLength)))
                    .map(x => allCharacters[x % allCharacters.length]);

                const passwordArray = mandatoryChars.concat(remainingChars);

                // Shuffle the array to avoid predictable placement of the mandatory characters (Fisher-Yates shuffle)
                for (let i = passwordArray.length - 1; i > 0; i--) {
                    const j = crypto.getRandomValues(new Uint32Array(1))[0] % (i + 1);
                    [passwordArray[i], passwordArray[j]] = [passwordArray[j], passwordArray[i]];
                }

                return passwordArray.join('');
            };

            const randomPassword = generatePassword();
            setGenRandPass(randomPassword);
            const customerHibidInfo = customerInfoRes.data.allCustomer.data[0];
            const encryptedPassword = CryptoJS.AES.encrypt(randomPassword, process.env.REACT_APP_FRONT_END_ENCRY_KEY).toString();

            const response = await regWithPassNoValid({
                variables: {
                    email: customer.Email,
                    address: customerHibidInfo.CustomerHiBidInfoID.Street,
                    city: customerHibidInfo.CustomerHiBidInfoID.City,
                    country: customerHibidInfo.CustomerHiBidInfoID.Country,
                    fax: customerHibidInfo.CustomerHiBidInfoID.fax,
                    FirstName: customerHibidInfo.FirstName,
                    LastName: customerHibidInfo.LastName,
                    MiddleName: customerHibidInfo.MiddleName,
                    NickName: customerHibidInfo.FirstName.charAt(0).toUpperCase() + customerHibidInfo.LastName.charAt(0).toUpperCase() + Date.now(),
                    Phone: customerHibidInfo.CustomerHiBidInfoID.Phone,
                    province: customerHibidInfo.CustomerHiBidInfoID.Province,
                    registerPassword: encryptedPassword,
                    unit: customerHibidInfo.CustomerHiBidInfoID.UnitNum,
                    zip: customerHibidInfo.CustomerHiBidInfoID.PostalCode,
                    setPrimaryAddress: true
                }
            });

            if (response?.data.RegisterCreateCustomerFVal.success) {
                refetch();
                Swal.fire({
                    icon: 'success',
                    title: t('Customer Created. They may login use the following password now.'),
                    html: `
                            <p class='swal-html-p-css success'>Customer's Password: </p>
                            <p class='swal-html-p-css success'>${randomPassword}</p>
                        `,
                    showConfirmButton: true,
                    confirmButtonText: t('Close'),
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('Failed to Register Email'),
                    text: `${response.data.RegisterCreateCustomerFVal.message || t("Failed to Register email, please try again.")}`,
                    confirmButtonText: t('Close'),
                });
            }
        } catch (error) {
            Swal.fire('Lost connection with the server. Please try again after a few seconds and refresh the page.');
            console.error(error);
            return false;
        }

    }

    return (
        <div className='main-container'>
            <div className='per-customer-detail'>
                <button className="return-button" onClick={() => navigate(`${origin}`)}>
                    <IoMdReturnLeft />
                </button>
                <div className='per-customer-detail-title'>
                    <h1>{customer.FirstName} {customer.LastName}</h1>
                    {customer.Password !== null ? <label>Registered</label> :
                        <span>
                            <button onClick={registerRandomTempPassword}>Random Password Registration</button>
                            <button onClick={sendRegistrationEmail}>send registration email</button>
                            <label>Not Registered</label>
                        </span>
                    }
                </div>
                {genRandPass && <>
                    <p>Temp Password:</p>
                    <p>{genRandPass}</p>
                </>}
                <div className='whole-customer-data-set-part'>
                    <div className='customer-data-set-part'>
                        <div className='set-sata-show-part'>
                            <input type="checkbox" checked={customer.IsCashPayer} disabled />
                            <label>{t('IsCashPayer')}</label>
                        </div>
                        <div className='set-operation-part' onClick={handleSetCashPayer}>
                            {customer.IsCashPayer ? 'Cancel' : 'Set Cash Payer'}
                        </div>
                    </div>
                    <div className='customer-data-set-part'>
                        <label className='set-sata-show-part'>{t('Account Level:')} {customer.AccountLevel}
                        </label>
                        <div className='set-operation-part' onClick={handleEditAccountLevel}>{t('Edit Account')}</div>
                    </div>
                    <div className='customer-data-set-part'>
                        <a onClick={showCreditHistory} className='set-sata-show-part'><u>{t('Credit:')} {customer.Credit}</u></a>
                        <div className='set-operation-part' onClick={handleEditCredit}>{t('Edit Credit')}</div>
                    </div>
                    <div className='customer-data-set-part note-set-part'>
                        <span className='set-sata-show-part'>{customer.Note || "No additional note"}</span>
                        <div className='set-operation-part' onClick={handleEditNotice}>{t('Edit Notice')}</div>
                    </div>
                </div>

                <div className='per-customer-data-show-part'>
                    <div className='customer-per-table-part'>
                        <h2 className='sub-title'>{t('📁 Customer Info')}</h2>
                        <DataTable
                            headers={customerInfoHeaders}
                            data={[customer]}
                        />
                    </div>
                    <div className='customer-per-table-part'>
                        <h2 className='sub-title'>{t('🏠 Address')}</h2>
                        <DataTable
                            headers={addressHeaders}
                            data={[customer.CustomerInfoID || {}]}
                        />
                    </div>
                    <div className='customer-per-table-part'>
                        <h2 className='sub-title'>{t('🏠 HIBID Address')}</h2>
                        <DataTable
                            headers={addressHeaders}
                            data={[customer.CustomerHiBidInfoID || {}]}
                        />
                    </div>
                    <div className='customer-per-table-part not-fixed-pagination'>
                        <h2 className='sub-title'>{t('🧾 Auction Details')}</h2>
                        <div>
                            <SearchBarGraph
                                onSearch={handleSearch}
                                onReset={handleReset}
                                searchTerm={search}
                                searchOptions={searchOptions}
                                selectedOptions={selectedOptions}
                                onSearchByChange={handleSearchByChange}
                            />
                            <DataTable
                                headers={auctionHeaders}
                                data={auctionData}
                                renderRow={renderAuctionRow}
                                onHeaderClick={handleHeaderClick}
                                orderBy={orderBy}
                            />
                            <Pagination
                                page={page}
                                pageSize={pageSize}
                                totalPageNum={totalPageNum}
                                totalCount={totalCount}
                                onPageChange={handlePageChange}
                                onPageSizeChange={handlePageSizeChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {swalShown &&
                createPortal(
                    <CustomerCreditLog id={id} />,
                    Swal.getHtmlContainer()
                )
            }
        </div>
    );
}

export default CustomerDetail;